export const formatearTamaño = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const tamaños = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + tamaños[i];
};

export const generarIdUnico = (): string => {
  return `${Date.now()}-${Math.random()}`;
};

export const crearImagenProducto = (file: File, preview: string) => {
  return {
    id: generarIdUnico(),
    file,
    preview,
    nombre: file.name,
    tamaño: file.size,
    tipo: file.type,
  };
}; 